<template>
  <span>
    <v-navigation-drawer app v-model="drawer" class="white lighten-2" light disable-resize-watcher>
      <v-list>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>{{fullname}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile v-if="!isLoggedIn" @click.stop="showLoginForm=true">
          <v-list-tile-content>
            <v-list-tile-title>تسجيل الدخول</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile v-if="isLoggedIn" :to="{name:'missings.create'}">
          <v-list-tile-content>
            <v-list-tile-title>بلاغ جديد</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile v-if="isLoggedIn" :to="{name:'missings.usermissings'}">
          <v-list-tile-content>
            <v-list-tile-title>بلاغاتي</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile v-if="isLoggedIn" @click="logout">
          <v-list-tile-content>
            <v-list-tile-title>تسجيل الخروج</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile v-if="!isLoggedIn" @click.stop="showRegisterForm=true">
          <v-list-tile-content>
            <v-list-tile-title>التسجيل</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar d-block app color="white darken-4">
      <v-toolbar-side-icon class="hidden-md-and-up" @click="drawer = !drawer" />

      <v-toolbar-title>
        <router-link :to="{name:'home'}">
          <img src="../assets/logo.png" height="40" />
        </router-link>
      </v-toolbar-title>

      <v-spacer />
      <router-link :to="{name:'missings.create'}">
        <v-btn outline color="success">بلاغ جديد</v-btn>
      </router-link>
      <v-btn
        v-if="!isLoggedIn"
        flat
        class="hidden-sm-and-down"
        @click.stop="showLoginForm=true"
      >تسجيل الدخول</v-btn>
      <user-menu v-if="isLoggedIn" :fullname="fullname"></user-menu>
      <login v-model="showLoginForm"></login>
      <v-btn v-if="isLoggedIn" flat class="hidden-sm-and-down" @click="logout">تسجيل الخروج</v-btn>
      <v-btn
        v-if="!isLoggedIn"
        @click.stop="showRegisterForm=true"
        color="primary "
        class="hidden-sm-and-down"
      >التسجيل</v-btn>
      <register v-model="showRegisterForm"></register>
    </v-toolbar>
  </span>
</template>

<script>
import Login from "./account/Login";
import Register from "./account/Register";
import UserMenu from "./account/UserMenu";
import { mapActions, mapState } from "vuex";
export default {
  name: "AppNavigation",
  components: {
    Login,
    Register,
    UserMenu
  },
  data() {
    return {
      showLoginForm: false,
      showRegisterForm: false,
      drawer: false,
      items: [
        { title: "القائمة" },
        { title: "تسجيل الدخول" },
        { title: "التسجيل" }
      ]
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.AuthStore.user.token !== null,
      fullname: state => state.AuthStore.user.fullname
    })
  },
  methods: {
    ...mapActions(["logout"])
  }
};
</script>

<style scoped>
</style>